import { ColumnDef } from "@tanstack/react-table";
import cn from "classnames";
/* eslint-disable react-hooks/exhaustive-deps */
import { t } from "i18next";
import moment from "moment";
import { useMemo } from "react";
import { ItemsTable } from "ui";

import {
  formatBoxMovementRef,
  getBoxMovementActorName,
  getBoxMovementZoneLabel,
} from "../../helpers";
import { BoxMovement } from "../../transfers.types";
import { BoxMovementsTableProps } from "./BoxMovementsTable.types";

import styles from "./BoxMovementsTable.module.scss";

const BoxMovementsTable = ({
  boxMovements,
  isLoading,
  sorting,
  setSorting,
}: BoxMovementsTableProps) => {
  const columns: Array<ColumnDef<BoxMovement>> = useMemo(
    () => [
      {
        id: "ref",
        header: t("Reference"),
        enableSorting: false,
        size: 14,
        minSize: 14,
        cell: ({ row }) => (
          <span className={styles.ref}>
            {formatBoxMovementRef(row.original.id)}
          </span>
        ),
      },
      {
        header: t("Type"),
        enableSorting: false,
        size: 16,
        minSize: 16,
        cell: ({ row }) => (
          <span
            className={cn(styles.type, styles[`type__${row.original.zone}`])}
          >
            {t(getBoxMovementZoneLabel(row.original.zone))}
          </span>
        ),
      },
      {
        header: t("From"),
        enableSorting: false,
        size: 16,
        minSize: 16,
        cell: ({ row }) => (
          <span className={styles.box}>
            {row.original.fromInventoryBox?.name ??
              row.original.fromInventoryBoxId}
          </span>
        ),
      },
      {
        header: t("To"),
        enableSorting: false,
        size: 16,
        minSize: 16,
        cell: ({ row }) => (
          <span className={styles.box}>
            {row.original.toInventoryBox?.name ?? row.original.toInventoryBoxId}
          </span>
        ),
      },
      {
        header: t("Articles"),
        enableSorting: false,
        size: 8,
        minSize: 8,
        cell: ({ row }) => row.original.articlesCount,
      },
      {
        header: t("Created by"),
        enableSorting: false,
        size: 16,
        minSize: 16,
        cell: ({ row }) => getBoxMovementActorName(row.original),
      },
      {
        id: "createdAt",
        accessorKey: "createdAt",
        header: t("Created"),
        size: 14,
        minSize: 14,
        cell: ({ row }) =>
          moment(row.original.createdAt).format("DD MMM YYYY, HH:mm"),
      },
    ],
    [boxMovements],
  );

  return (
    <ItemsTable
      columns={columns}
      data={boxMovements}
      sorting={sorting}
      skeletonHeight={56}
      setSorting={setSorting}
      isLoading={isLoading}
      rowsClassName={styles.tallRow}
      emptyListMessage="No box movements yet"
    />
  );
};

export default BoxMovementsTable;
